import moment from "moment";
export default {
    getAge: (date) => {
        let years = moment().diff(moment(date), "years");
        if (years > 0) {
            return years + " years";
        }
        return moment().diff(moment(date), "months") + " mths";
    },
    getAgeMoment(birthdate) {
        var m = moment(birthdate, "YYYY-MM-DD");  
        var years = moment().diff(m, "years", false);
        var months = moment().diff(m.add(years, "years"), "months", false);
        var monthString = "";
        var yearString = "";
        var age = "";
        if (years > 1) {
          yearString = " years";
        } else {
          yearString = " year";
        }
        if (months > 1) {
          monthString = " months";
        } else {
          monthString = " month";
        }
        if (years > 0 && months > 0) {
          age = years + yearString + ", " + months + monthString;
        } else if (years > 0 && months == 0) {
          age = years + yearString;
        } else if (years == 0 && months > 0) {
          age = +months + monthString;
        } else {
          age = "";
        }
        return age;
      },
    getDate: (date, formart = "DD-MM-YYYY") => {
        let result = moment(date).format(formart)
        return result;
    },
    getDateOfMonday: (date = null) => {
        let formattedDate = moment(date ? date : {}).format('YYYY-MM-DD');
        //console.debug('formattedDate', formattedDate)
        let indexOfWeek = moment(formattedDate).format('E') - 1;
        //console.debug('indexOfWeek', indexOfWeek)
        if (indexOfWeek == 0) {
            return formattedDate;
        }
        let newDate = moment(formattedDate).add(-indexOfWeek, 'days').format('YYYY-MM-DD')
        return newDate;
    },
    getFriendlyDate: (date, formart = "DD/MM/YYYY") => {
        let days = moment().diff(moment(date), "days");
        switch (days) {
            case 0:
                return 'Today';
            case 1:
                return 'Yesterday';
            default:
                return moment(date).format(formart);

        }
    },
    isClickOnDatePicker: (event) => {
        // if (!event.path) {
        if (!event.composedPath()) {
            return false;
        }
        let found = false;
        event.composedPath().map(ele => {
            if (ele.classList && ele.classList.length) {
                for (let i in ele.classList) {
                    // console.log("ele.classList[i]: ", ele.classList[i]);
                    if (ele.classList[i] === 'mx-datepicker-main') {
                        found = true;
                        break;
                    }
                }
            }
        })
        return found
    }
}